/**
 * A "Fluency Reading" (or just "reading") is:
 *
 *   - The moral equivalent of an exam, linking a lesson/day to an "answer" (video).
 *   - Not a DB entity like StudentExamResult, but generated from other domain objects.
 *   - An abstraction used in the "grading" and "review" flows, but not (yet) "take".
 */
export type FluencyRecording = {
  id: number
  classification: FluencyRecordingClassification
  label: string
  url: string
  day_of_week: number
  lesson: FluencyLesson
  grade: FluencyGrade | null
  lyrics_only: boolean
}

export type FluencyRecordingClassification = "cold_read" | "hot_read" | "stitched" | "benchmark"

/** Represents all the readings for a given lesson, keyed by cold/hot/benchmark classification */
export type FluencyRecordingSet = Partial<Record<FluencyRecordingClassification, FluencyRecording>>

export type FluencyLesson = {
  title: string
  lexile_measure: string
  subject: string
  storygenre: string
  wordspermin: string
  lessontext: string
  lessontext_legacy: string
}

export type FluencyGrade = {
  wpm: number
  accuracy: number
  expression: number
  feedback: string
  selectedWordIds: string[]
}

export function lessonTextForGrade(lesson: FluencyLesson, grade: FluencyGrade | null): string {
  const selected = grade?.selectedWordIds
  if (!selected?.length) return lesson.lessontext
  return selected.every(id => /^\d+$/.test(id)) ? lesson.lessontext_legacy : lesson.lessontext
}

// Works with both legacy and new format
export function markupSelectedAndWpm(html: string, errorClass: string, ids: string[], wpm: number): string {
  console.log({ids, wpm})

  // replace legacy, adding classes as appropriate
  ids.forEach((id: string) =>
    html = html.replace(`l2l-id="${id}" class="l2l-word`, `"l2l-id=${id}" class="l2l-word ${errorClass}`)
  )

  html = html.replace(`l2l-id="${wpm}" class="l2l-word`, `"${wpm}" class="l2l-word wpm-marker`)

  // <span l2l-word-id='the-9' l2l-word-index='228'>
  // replace new.  note single quotes and custom attributes instead of class
  ids.forEach((id: string) => html = html.replace(`l2l-word-id='${id}'`, `l2l-word-id='${id}' l2l-${errorClass}-error`))

  html = html.replace(`l2l-word-index='${wpm}'`, `l2l-word-index='${wpm}' l2l-wpm-marker`)

  return html
}
